// extracted by mini-css-extract-plugin
export var animationContainer = "_j3-0";
export var asteriskIcon = "_j3-8";
export var conversationLeftSection = "_j3-4";
export var conversationListItem = "_j3-3";
export var conversationMiddleSection = "_j3-5";
export var conversationRightSection = "_j3-6";
export var detailsContent = "_j3-1";
export var listContainer = "_j3-7";
export var modalContent = "_j3-2";